import { router } from '@/plugins/vue-router'
import { getSelectedLanguage } from '@/services/authService'


export function routeFromRoot(url) {
  router.push(`/${getSelectedLanguage()}/${url}`)
}
export function routeToNewWindow(url, target, replace, system) {
  window.open(system && system !== undefined ? `${location.origin}/${getSelectedLanguage()}/${url}` : url, (target && target !== undefined ? target : '_blank'), '', replace && replace !== undefined ? replace : false)
}